import { generateUserAgentHeader, urls } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';

type GetCareTeamConnectionArgs = {
  userId: string;
  appVersion?: string;
  osType?: string;
  osVersion?: string;
};

export const getCareTeamConnections = async ({
  userId,
  appVersion,
  osType,
  osVersion,
}: GetCareTeamConnectionArgs) => {
  const result = await mediator.request<ApiResponse<{ data: CareTeamConnection[] }>>('api:invoke', {
    method: 'GET',
    url: `${urls.clmApiUrl}${userId}/connections/list`,
    headers: {
      'X-User-Agent': generateUserAgentHeader('clm', appVersion, osType, osVersion),
    },
  });

  if (result.data) {
    return result.data.data;
  }

  throw result;
};

type AddCareTeamConnectionArgs = {
  userId: string;
  clinicId: string;
  appVersion?: string;
  osType?: string;
  osVersion?: string;
};

export const addCareTeamConnection = async ({
  userId,
  clinicId,
  appVersion,
  osType,
  osVersion,
}: AddCareTeamConnectionArgs) => {
  const result = await mediator.request<ApiResponse<CareTeamConnectionAddResponse>>('api:invoke', {
    method: 'POST',
    url: `${urls.clmApiUrl}${userId}/connections/add`,
    headers: {
      'X-User-Agent': generateUserAgentHeader('clm', appVersion, osType, osVersion),
    },
    data: {
      clinicId,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};
